// themetitle.js
const themeTitleConfig = {
  title: "Ask Bud-I",
  version: "1.0.0",
  description: "A fantastic web application",
  author: "Your Name"
};

export default themeTitleConfig;